<template>
  <BravadoTextInputV3 ref="input" v-bind="attrs" :class="rootClass" v-on="$listeners">
    <template v-for="(index, name) in $slots" #[name]>
      <slot :name="name" />
    </template>
  </BravadoTextInputV3>
</template>

<script>
import BravadoTextInputV3 from '@/components/common/BravadoTextInputV3/BravadoTextInputV3.vue';

export default {
  name: 'JobsInput',
  components: {
    BravadoTextInputV3,
  },
  props: {
    numeric: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rootClass() {
      return {
        'jobs-input': true,
        'jobs-input--icon': this.$slots.icon,
      };
    },
    attrs() {
      if (!this.numeric) return this.$attrs;

      const numericAttrs = {
        min: '0',
        inputmode: 'numeric',
        pattern: '[0-9]*',
      };

      return { ...this.$attrs, ...numericAttrs };
    },
  },
};
</script>

<style scoped lang="scss">
.jobs-input {
  ::v-deep .bravado-text-input-v3__field {
    @include header3;

    margin-top: 2px;
    padding: 16px;
    height: auto;

    &::placeholder {
      color: var(--theme-color-border);
    }
  }

  ::v-deep .bravado-text-input-v3__field-textarea {
    @include body;

    padding: 12px;
    min-height: 120px;
  }

  ::v-deep .bravado-text-input-v3__icon {
    @include header2;

    color: var(--gray-50);
    left: 16px;
  }

  &--icon {
    ::v-deep .bravado-text-input-v3__field {
      padding-left: 49px;
    }
  }

  ::v-deep .bravado-text-input-v3__hint {
    @include subhead-semibold;

    margin-top: 6px;
  }
}
</style>
